export default "https://cdn-static.gokick.com/assets/6909edbc169b94fbe838446b12805066cb856688/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";